import { useEffect, useState } from "react";
import {
  Row,
  Layout,
  Typography,
  Col,
  Button,
  Modal,
  Select,
  Form,
  Upload,
  Card,
  message,
  Divider,
  Alert,
  Checkbox,
  Spin,
  Breadcrumb,
} from "antd";
import "../tutorialpage/styles/index.less";
import { useNavigate, useParams } from "react-router-dom";
import {
  AuditOutlined,
  CheckCircleOutlined,
  CopyOutlined,
  InboxOutlined,
  SendOutlined,
  TrophyOutlined,
} from "@ant-design/icons";
import {
  get_model,
  get_tutorial,
  submit_model,
  get_SubmissionDraft,
  submit_draft,
  submit_draft_delete,
  get_getLimitSubmission,
} from "../../services/submission";
import { useAuth } from "../../utils/Auth/AuthWrapper";
import { get_task_by_id } from "../../services/task";
import { get_profile, get_role } from "../../services/user";
import { post_uploadResult } from "../../services/uploads";
import moment from "moment";
import { setting_all } from "../../services/setting";
import { queue_submit } from "../../services/submission";
import { useTranslation } from "react-i18next";
import { useSocket } from "../../utils/socketio/SocketWrapper";
import { get_task_member } from "../../services/task_member";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const { Content } = Layout;
const { Title, Text } = Typography;

type QueueItem = {
  name: string;
  messages_ready: number;
};

type Props = {};

const Tutorialpage = (props: Props) => {
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const params = useParams();
  const { t } = useTranslation();
  const auth = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [model, setModel] = useState("");
  const [selectedModel, setSelectedModel] = useState([
    {
      value: "ai9-llm/hin:llm-1+sha256:4ca5c2d258d5ef867b7ad5decc6",
      label: "llm-1",
    },
  ]);
  const [userData, setUser] = useState({
    user_name: "",
    user_code: "",
    org_name: "",
    user_email: "",
    profile_img: "",
    role_name: "",
  });
  const [task, setTask] = useState<any>({
    name: "test",
    submission_type: 1,
  });
  const [dataset, setDataset] = useState<any>([]);
  const [tutorial, setTutorial] = useState({
    login: "",
    logout: "",
    image_pull: "",
    image_push: "",
    image_tag: "",
  });
  const toggleModal = () => setIsModalOpen((prev) => !prev);
  const [disabledSubmiss, setDisabledSubmiss] = useState(true);
  const [nametask, setNametask] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [pathUploadFile, setPathUploadFile] = useState<any>("");
  const [subType, setSubType] = useState<any>(1);
  const [countQueue, setcountQueue] = useState<any>(0);
  const { socket } = useSocket();

  const [systemRole, setSystemRole] = useState<any>(null);
  const [memberRole, setMemberRole] = useState<any>(null);

  useEffect(() => {
    if (socket.current) {
      socket.current.on("getqueue", (data: any) => {
        // console.log("test queue socket");
        getQueue();
      });
    }
  }, [socket.current]);

  // get api
  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingData(true);
      await getTutorial();
      getModel();
      await getProfile();
      await getTaskDetail();
      getQueue();
      getDraft();
      setIsLoadingData(false);
    };
    fetchData();
  }, []);

  // check member//
  const getMember = async (detail: any) => {
    try {
      const data = { task_id: params.task_id };
      const res = await get_task_member(data);
      const role = await get_role();
      const checkMember = res.data.filter((item: any) => {
        if (item.user_id == auth.user.user_id) {
          return true;
        }
      });

      // =============ตรวจสอบ==================
      if (detail[0].status == 0) {
        if (role.result[0].role_name != "Super Admin") {
          if (checkMember.length == 0 || checkMember[0].role == 1) {
            navigate("/");
          }
        }
      }
      setMemberRole(checkMember[0]?.role);
      setSystemRole(role.result[0]?.role_name);
      // =======
    } catch (e) {
      console.error(e);
    }
  };

  // get profile
  const getProfile = async () => {
    try {
      const res = await get_profile();
      const user = res.result;
      if (!user || user.length === 0 || !user[0]) {
        navigate("/");
        return;
      }
      setUser(user[0]);
    } catch (error) {
      console.error(error);
      navigate("/");
    }
  };

  // get tag code box
  const getTutorial = async () => {
    try {
      const res = await get_tutorial({ task_id: params.task_id });
      setTutorial(res);
    } catch (error) {
      console.error(error);
    }
  };

  // get queue all
  const getQueue = async () => {
    try {
      const res = await queue_submit();
      const parsedData =
        typeof res.data === "string" ? JSON.parse(res.data) : res.data;
      const queues = parsedData?.queues || parsedData?.data?.queues || [];
      if (Array.isArray(queues)) {
        const totalMessages = queues.reduce(
          (sum: number, queue: any) => sum + queue.messages_ready,
          0,
        );
        setcountQueue(totalMessages);
      } else {
        setcountQueue(0);
      }
    } catch (e) {
      console.error("❌ Error fetching queue data:", e);
      setcountQueue(0);
    }
  };

  const getModel = async () => {
    const res = await get_model({
      task_id: params.task_id,
      user_code: userData.user_code,
    });
    let model_list = [];
    for (let a in res.images) {
      // let name = res.images[a].image.toString().split(":");
      let name = res.images[a].image.toString().split("/");
      let item = {
        label: name[2],
        value: res.images[a].image + "+" + res.images[a].digest,
      };
      model_list.push(item);
    }
    setSelectedModel(model_list);
  };

  const getTaskDetail = async () => {
    try {
      const res = await get_task_by_id({ task_id: params.task_id });

      if (
        !res.result ||
        !Array.isArray(res.result) ||
        res.result.length === 0
      ) {
        navigate("/404");
        return;
      }
      getMember(res.result);
      const taskData = res.result[0];

      // ✅ ตรวจสอบว่า task หมดเวลา
      const now = dayjs();
      const end = dayjs(taskData.end_date);
      if (now.isAfter(end)) {
        message.warning(t("This task has expired"));
        navigate("/task");
        return;
      }

      // ✅ ถ้ายังไม่หมดเวลา ก็ทำงานต่อ
      const datasetParsed = taskData?.dataset
        ? JSON.parse(taskData.dataset).dataset
        : {};

      setNametask(taskData.name);
      setSubType(taskData.submission_type);
      setTask(taskData);

      const hasPublic =
        datasetParsed?.public && datasetParsed.public.length > 0;
      const hasPrivate =
        datasetParsed?.private && datasetParsed.private.length > 0;

      const datasetToUse = hasPrivate
        ? datasetParsed.private
        : hasPublic
          ? datasetParsed.public
          : [];

      const datasetOptions = datasetToUse.map((item: any, index: number) => ({
        ...item,
        label: item.desciption,
        value: index,
      }));

      setDataset(datasetOptions);
      getSubmission(taskData);
    } catch (error) {
      console.error("Error fetching task detail:", error);
      navigate("/404"); // ✅ fallback ถ้า API error เช่น 500/404
    }
  };

  const submitModel = async () => {
    // const formData = form.getFieldsValue();
    form.submit();
  };

  const handleFinish = async (value: any) => {
    try {
      const model_split = model.toString().split("+");
      const data =
        subType == 1
          ? {
              task_id: params.task_id,
              user_id: auth.user.user_id,
              docker_id: model_split[1],
              docker_image: model_split[0],
              datasets: dataset.filter((item: any) =>
                value.dataset.includes(item.value),
              ),
            }
          : {
              task_id: params.task_id,
              user_id: auth.user.user_id,
              docker_id: "00000000",
              docker_image: pathUploadFile,
              datasets: [],
            };
      const res = await submit_model(data);
      if (res.status == "success") {
        getSubmission(task);
        setDataFile(null);
        setUploadSuccess(false);
        message.success("Submit successfully!");
        setIsModalOpen(false);
      } else {
        message.error("Submit fail!");
      }
    } catch (error) {
      console.error("Submission Error:", error);
      setDisabledSubmiss(false);
    }
  };

  const truncateTitle = (title: any, maxLength: any) => {
    if (title.length > maxLength) {
      return title.substring(0, maxLength) + "...";
    }
    return title;
  };

  const getSubmission = async (task_detail: any) => {
    try {
      const date = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      const system_config = await setting_all();
      const configs_data: any = JSON.parse(system_config.data[0].configs);
      let dateinfo = { start_date: "", end_date: "" };
      if (
        moment(date).unix() <
        moment(
          moment(new Date()).format(
            `YYYY-MM-DD ${
              task_detail.submission_time == null
                ? configs_data.time_start_task
                : task_detail.submission_time
            }`,
          ),
        ).unix()
      ) {
        // if (moment(date).hour() < 8) {
        dateinfo.start_date = moment(new Date())
          .subtract(1, "days")
          .format(
            `YYYY-MM-DD ${
              task_detail.submission_time == null
                ? configs_data.time_start_task
                : task_detail.submission_time
            }`,
          );
        dateinfo.end_date = moment(new Date()).format(
          `YYYY-MM-DD ${
            task_detail.submission_time == null
              ? configs_data.time_start_task
              : task_detail.submission_time
          }`,
        );
      } else {
        dateinfo.start_date = moment(new Date()).format(
          `YYYY-MM-DD ${
            task_detail.submission_time == null
              ? configs_data.time_start_task
              : task_detail.submission_time
          }`,
        );
        dateinfo.end_date = moment(new Date())
          .add(1, "days")
          .format(
            `YYYY-MM-DD ${
              task_detail.submission_time == null
                ? configs_data.time_start_task
                : task_detail.submission_time
            }`,
          );
      }
      const data = {
        task_id: params.task_id,
        filter: dateinfo,
      };
      const res = await get_getLimitSubmission(data);
      if (task_detail.submission_type == 1) {
        if (task_detail.submission_limit <= res.result.length) {
          setDisabledSubmiss(true);
        } else {
          const status = [0, 1, 2];
          const checkProgress =
            res.result &&
            res.result.filter((item: any) => {
              return status.includes(item.status);
            });
          if (checkProgress.length != 0) {
            setDisabledSubmiss(true);
          } else {
            setDisabledSubmiss(false);
          }
        }
      } else if (task_detail.submission_type == 2) {
        if (task_detail.submission_limit <= res.result.length) {
          setDisabledSubmiss(true);
        } else {
          setDisabledSubmiss(false);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getDraft = async () => {
    try {
      const data = {
        task_id: params.task_id,
      };
      const res = await get_SubmissionDraft(data);
      if (res.status === "success") {
        const subDraft = res.data[0];
        form.setFieldsValue({
          file: subDraft?.docker_image,
          model: subDraft?.docker_image
            ? subDraft?.docker_image + "+" + subDraft?.docker_id
            : null,
          dataset: res.data[0]?.dataset[0]
            ? [Number(JSON.parse(res.data[0]?.dataset)[0]?.value)]
            : null,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const saveDraft = async () => {
    try {
      const docker_info = model.split("+");
      const data = {
        task_id: params.task_id,
        docker_id: docker_info[1] ? docker_info[1] : "",
        docker_image: docker_info[0] ? docker_info[0] : "",
        datasets: dataset.filter((item: any) =>
          form.getFieldValue("dataset")?.includes(item.value),
        ),
      };
      const res = await submit_draft(data);
      if (res.status === "success") {
        setIsModalOpen(false);
        message.success("Draft saved successfully!");
      }
    } catch (e) {
      console.error(e);
      message.error("Draft saved Failed!");
    }
  };

  const clearDraft = async () => {
    try {
      const data = {
        task_id: params.task_id,
      };
      const res = await submit_draft_delete(data);
      if (res.status === "success") {
        form.resetFields();
        setIsModalOpen(false);
        message.success("Clear Draft successfully!");
      }
    } catch (e) {
      console.error(e);
      message.error("Clear Draft failed!");
    }
  };

  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [dataFile, setDataFile] = useState<any>();
  const propsDragger = {
    name: "file",
    multiple: false,
    showUploadList: false,
    action: "",
    onChange: async (info: any) => {},
    onDrop(e: any) {},
    beforeUpload: async (file: any, fileList: any) => {
      setUploadSuccess(false);
      setIsLoading(true);
      const data = {
        task_id: params.task_id,
        type: file.type,
        name: file.name,
        file: file,
        user_id: auth.user.user_id,
      };
      const res = await post_uploadResult(data);
      if (res.status == "success") {
        setDataFile(file.name);
        setUploadSuccess(true);
        setPathUploadFile(res.link);
        setIsLoading(false);
      }
      return false;
    },
  };

  return (
    <div>
      <Content className="tutorial-layout">
        {/* header */}
        <div>
          <Row justify="space-between" align="middle">
            <Col>
              <Breadcrumb
                separator=">"
                items={[
                  {
                    title: (
                      <a
                        style={{ fontWeight: "bold" }}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/task");
                        }}
                      >
                        {t("Task")}
                      </a>
                    ),
                  },
                  {
                    title: (
                      <a
                        style={{ fontWeight: "bold" }}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/task/detail/" + params.task_id);
                        }}
                      >
                        {truncateTitle(task.name, 20)}
                      </a>
                    ),
                  },
                  {
                    title: (
                      <span style={{ fontWeight: "bold" }}>
                        {t("Submission")}
                      </span>
                    ),
                  },
                ]}
              />
            </Col>

            <Col>
              {systemRole == "Super Admin" ||
              // ชั่วคราว
              memberRole == 2 ? (
                <>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#FFF4CC",
                      borderColor: "#DD761C",
                      color: "#DD761C",
                      marginRight: "10px",
                    }}
                    onClick={() =>
                      navigate(`/score/leaderboard/${params.task_id}`)
                    }
                  >
                    <TrophyOutlined style={{ color: "#DD761C" }} />
                    {t("Leaderboard")}
                  </Button>
                  <Button
                    type="primary"
                    disabled={disabledSubmiss}
                    style={{
                      backgroundColor: disabledSubmiss ? "#d9d9d9" : "#ffd1b3",
                      borderColor: disabledSubmiss ? "#bfbfbf" : "#ff751a",
                      color: disabledSubmiss ? "#8c8c8c" : "#ff751a",
                      marginRight: "10px",
                    }}
                    onClick={toggleModal}
                  >
                    <SendOutlined />
                    {disabledSubmiss ? t("Limit reached") : t("Submission")}
                  </Button>
                </>
              ) : dayjs().isBefore(dayjs(task?.start_date)) &&
                memberRole != 2 ? null : (
                <>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#FFF4CC",
                      borderColor: "#DD761C",
                      color: "#DD761C",
                      marginRight: "10px",
                    }}
                    onClick={() =>
                      navigate(`/score/leaderboard/${params.task_id}`)
                    }
                  >
                    <TrophyOutlined style={{ color: "#DD761C" }} />
                    {t("Leaderboard")}
                  </Button>
                  <Button
                    type="primary"
                    disabled={disabledSubmiss}
                    style={{
                      backgroundColor: disabledSubmiss ? "#d9d9d9" : "#ffd1b3",
                      borderColor: disabledSubmiss ? "#bfbfbf" : "#ff751a",
                      color: disabledSubmiss ? "#8c8c8c" : "#ff751a",
                      marginRight: "10px",
                    }}
                    onClick={toggleModal}
                  >
                    <SendOutlined />
                    {disabledSubmiss ? t("Limit reached") : t("Submission")}
                  </Button>
                </>
              )}

              <Button
                type="primary"
                style={{
                  backgroundColor: "#EFCEFF",
                  borderColor: "#AF52DE",
                  color: "#AF52DE",
                  marginRight: "10px",
                }}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/task/submission/${params.task_id}`);
                }}
              >
                <AuditOutlined />
                {t("History")}
              </Button>
            </Col>
          </Row>
          <hr />
        </div>

        {/* body */}
        <div style={{ marginTop: "20px" }}>
          {isLoadingData ? (
            <Row justify="center" align="middle" style={{ height: "50vh" }}>
              <Spin size="large" />
            </Row>
          ) : (
            <>
              {task.submission_type === 1 ? (
                <>
                  <div>
                    <Row gutter={[16, 16]} align="middle">
                      <Col xs={24} md={12}>
                        <Title level={3} style={{ margin: 0 }}>
                          {t("Using the Docker Registry")}
                        </Title>
                      </Col>
                      <Col
                        xs={24}
                        md={12}
                        style={{
                          textAlign: "right",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            margin: 0,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {t("Number of queues in the system")} {countQueue}{" "}
                          {t("Queue")}
                        </p>
                      </Col>
                    </Row>

                    <Divider />
                    <Title level={4}>{t("Login")}</Title>
                    <ul className="b">
                      <li style={{ userSelect: "text" }}>{t("Dictation")}</li>
                    </ul>
                    <Card className="code-block" bodyStyle={{ padding: 0 }}>
                      <Row align={"middle"} justify={"space-between"}>
                        <Col>
                          <span className="talk-code">{tutorial.login}</span>
                        </Col>
                        <Col style={{ marginLeft: "auto" }}>
                          <Button
                            type="default"
                            icon={<CopyOutlined />}
                            onClick={() => {
                              navigator.clipboard.writeText(tutorial.login);
                              message.success("Copied to clipboard!");
                            }}
                            style={{ marginLeft: "auto" }}
                          />
                        </Col>
                      </Row>
                    </Card>
                    <div className="exam-desciption">
                      <span style={{ fontSize: "16px", userSelect: "text" }}>
                        {t("Then enter the usercode")} ({userData.user_code}){" "}
                        {t("and user password")}
                      </span>
                    </div>

                    <Card className="code-block" bodyStyle={{ padding: 0 }}>
                      <Row align={"middle"} justify={"space-between"}>
                        <Col>
                          <span className="talk-code">
                            {userData.user_code}
                          </span>
                        </Col>
                        <Col style={{ marginLeft: "auto" }}>
                          <Button
                            // type="text"
                            type="default"
                            icon={<CopyOutlined />}
                            onClick={() => {
                              navigator.clipboard.writeText(userData.user_code);
                              message.success("Copied to clipboard!");
                            }}
                            style={{ marginLeft: "auto" }}
                          />
                        </Col>
                      </Row>
                    </Card>
                  </div>
                  {/* Push Image */}
                  <div>
                    <Title level={4} className="top-head">
                      {t("Push Image")}
                    </Title>
                    <ul className="b">
                      <li style={{ userSelect: "text" }}>
                        {t(
                          "Create the desired image by building or tagging it with the registry name in front",
                        )}
                      </li>
                    </ul>

                    {/* <span>การตั้งค่า USER_TAG ต้องกำหนดเป็นตัวพิมพ์เล็กเท่านั้น</span> */}
                    <Card className="code-block" bodyStyle={{ padding: 0 }}>
                      <Row align={"middle"} justify={"space-between"}>
                        <Col>
                          <span className="talk-code">
                            {tutorial.image_tag}
                          </span>
                        </Col>
                        <Col>
                          <Button
                            type="default"
                            icon={<CopyOutlined />}
                            onClick={() => {
                              navigator.clipboard.writeText(tutorial.image_tag);
                              message.success("Copied to clipboard!");
                            }}
                          />
                        </Col>
                      </Row>
                    </Card>
                    <div className="exam-desciption">
                      <span style={{ fontSize: "16px", userSelect: "text" }}>
                        {t(
                          "The USER_TAG setting must be set to lowercase only",
                        )}
                      </span>
                    </div>
                    <div className="exam-desciption">
                      <ul className="b">
                        <li style={{ userSelect: "text" }}>
                          {t("Push image into docker registry")}
                        </li>
                      </ul>
                    </div>
                    <Card className="code-block" bodyStyle={{ padding: 0 }}>
                      <Row align={"middle"} justify={"space-between"}>
                        <Col>
                          <span className="talk-code">
                            {tutorial.image_push}
                          </span>
                        </Col>
                        <Col>
                          <Button
                            type="default"
                            icon={<CopyOutlined />}
                            onClick={() => {
                              navigator.clipboard.writeText(
                                tutorial.image_push,
                              );
                              message.success("Copied to clipboard!");
                            }}
                          />
                        </Col>
                      </Row>
                    </Card>
                    <div className="exam-desciption">
                      <Alert
                        message={t("Note")}
                        description={t(
                          "After pushing, reload the page again to see the data changes",
                        )}
                        type="warning"
                      />
                    </div>
                  </div>
                  {/* การ logout */}
                  <div>
                    <Title level={4} className="top-head">
                      {t("Logout")}
                    </Title>
                    <ul className="b">
                      <li>{t("Dictation")}</li>
                    </ul>
                    <Card className="code-block" bodyStyle={{ padding: 0 }}>
                      <Row align={"middle"} justify={"space-between"}>
                        <Col>
                          <span className="talk-code">{tutorial.logout}</span>
                        </Col>
                        <Col>
                          <Button
                            type="default"
                            icon={<CopyOutlined />}
                            onClick={() => {
                              navigator.clipboard.writeText(tutorial.logout);
                              message.success("Copied to clipboard!");
                            }}
                          />
                        </Col>
                      </Row>
                    </Card>
                  </div>
                </>
              ) : (
                <div>
                  <Title level={4} className="top-head">
                    {t("How to submit File")}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        position: "absolute",
                        right: "50px",
                      }}
                    >
                      {t("Number of queues in the system")} {countQueue}{" "}
                      {t("Queue")}
                    </span>
                  </Title>

                  <ul className="b">
                    <p>
                      {t(
                        '1. Click "Submission" button to start new submission.',
                      )}
                    </p>
                    <p>
                      {t(
                        '2. Upload or drag & drop your file named "submission.csv" into the box area.',
                      )}
                    </p>
                    <p>{t('3. Click "Submit" to confirm the submission.')}</p>
                  </ul>

                  <Title level={4} className="top-head">
                    {t("History view")}
                  </Title>

                  <ul className="b">
                    <p>
                      {t(
                        '1. Click "History" button to view all previous submissions.',
                      )}
                    </p>
                    <p>
                      {t(
                        "2. Click on each row or button in the row to view more details.",
                      )}
                    </p>
                  </ul>
                </div>
              )}
            </>
          )}
        </div>

        {/* modal submission */}
        <Modal
          title="Submission"
          open={isModalOpen}
          onCancel={toggleModal}
          footer={
            <Row justify={"end"}>
              {subType == 1 && (
                <>
                  <Button key="clear" onClick={() => clearDraft()} danger>
                    {t("Clear Draft")}
                  </Button>

                  <Button key="draft" onClick={() => saveDraft()} type="dashed">
                    {t("Save Draft")}
                  </Button>
                </>
              )}

              <Button key="submit" type="primary" onClick={submitModel}>
                {t("Submit")}
              </Button>
            </Row>
          }
        >
          <Form
            layout="vertical"
            form={form}
            name="form_in_modal"
            initialValues={{ modifier: "public" }}
            onFinish={handleFinish}
          >
            <Row gutter={16}>
              <Col xs={8} sm={6} md={4} lg={3} xl={7}>
                <Text style={{ fontSize: 15 }}>{t("Task Name")} : </Text>
              </Col>

              <Col xs={16} sm={18} md={20} lg={21} xl={17}>
                {nametask}
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={8} sm={6} md={4} lg={3} xl={7}>
                <Text style={{ fontSize: 15 }}>{t("Submission Type")} : </Text>
              </Col>

              <Col xs={16} sm={18} md={20} lg={21} xl={17}>
                {task.submission_type === 1
                  ? "Model Submission"
                  : task.submission_type === 2
                    ? "Result File Submission"
                    : " - "}
              </Col>
            </Row>

            {task.submission_type == 1 && (
              <Form.Item
                name="model"
                label="Select Images"
                rules={[{ required: true, message: "Please select a model!" }]}
                style={{ marginTop: 10 }}
              >
                <Select
                  placeholder="---- Select images ----"
                  style={{ width: "100%", marginBottom: "20px" }}
                  value={model}
                  onChange={(value) => {
                    setModel(value);
                  }}
                  options={selectedModel}
                ></Select>
              </Form.Item>
            )}

            {task.submission_type == 2 && (
              <Form.Item
                name="file"
                label={t("Upload File")}
                rules={[{ required: true, message: "Please upload a file!" }]}
                style={{ marginTop: 10 }}
              >
                <Upload.Dragger {...propsDragger}>
                  <Spin spinning={isLoading}>
                    <div>
                      <p className="ant-upload-drag-icon">
                        {uploadSuccess ? (
                          <CheckCircleOutlined style={{ color: "green" }} />
                        ) : (
                          <InboxOutlined />
                        )}
                      </p>
                      <p className="ant-upload-text">
                        {uploadSuccess ? (
                          <>{dataFile}</>
                        ) : (
                          "Drag your File here, or browse"
                        )}
                      </p>
                    </div>
                  </Spin>
                </Upload.Dragger>
              </Form.Item>
            )}
            {task.submission_type !== 2 && dataset && dataset.length > 0 && (
              <Form.Item label={"Dataset"} name={"dataset"}>
                <Checkbox.Group options={dataset} onChange={(value) => ""} />
              </Form.Item>
            )}
          </Form>
        </Modal>
      </Content>
    </div>
  );
};

export default Tutorialpage;
